import gtm from '@/plugins/statistic/google-tag-manager';
import hubspot from '@/plugins/statistic/hubspot';

export default {
    install(Vue, { config }) {
        Vue.use(gtm, { config });
        Vue.use(hubspot, { config });
    },
};
